<form #hsnForm="ngForm" class="form-container">
  <div class="form-header">
    <div class="form-breadcrumb">
      <h3><a [routerLink]="['/hsn']">HSN / SAC</a> > {{ hsn.hsn_sac || 'Create' }}</h3>
    </div>
    <div class="form-actions">
      <button *ngIf="!isFormDisabled" [disabled]="onSaveDisable" type="submit" mat-flat-button color="primary" (click)="save(hsnForm.valid)">
        <mat-icon>save</mat-icon> Save
      </button>
      <button *ngIf="isFormDisabled" type="button" mat-stroked-button (click)="edit()">
        <mat-icon>edit</mat-icon> Edit
      </button>
      <button *ngIf="isFormDisabled" type="button" mat-flat-button color="primary" (click)="create()">
        <mat-icon>add</mat-icon> Create
      </button>
      <button *ngIf="!isFormDisabled" type="button" mat-stroked-button (click)="discardChanges()">Discard</button>
    </div>
  </div>
  <div class="form-card">
    <fieldset [disabled]="isFormDisabled">
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>HSN / SAC</mat-label>
            <input #name="ngModel" type="text" matInput name="hsn_sac" [(ngModel)]="hsn.hsn_sac" required>
            <mat-error *ngIf="name.invalid && name.touched">Required</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>GST (%)</mat-label>
            <input #gst="ngModel" type="text" matInput name="gst" [(ngModel)]="hsn.gst" required>
            <mat-error *ngIf="gst.invalid && gst.touched">Required</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Description</mat-label>
            <input type="text" matInput name="description" [(ngModel)]="hsn.description">
          </mat-form-field>
        </div>
      </div>
    </fieldset>
  </div>
  <app-audit-log-viewer model="hsn_sac" [recordId]="hsn.id"></app-audit-log-viewer>
</form>
